import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ApiRouteConfig} from "../../../config/api.route.config";
import {Notification} from './notification';
@Injectable()
export class NotificationsService {

  constructor(
      private readonly config: ApiRouteConfig,
      private readonly httpClient: HttpClient,
  ) { }
  
  create(notifcation: Notification) {
    return this.httpClient.post<number>(
        this.config.RESIENT_NOTIFICATIONS,
        notifcation,
        {withCredentials: true}
    );
  }
}
